const LogistyConsts = {
  okModalClass: {
    title: 'แจ้งเตือน',
    headerClass: 'p-2 border-bottom-0',
    footerClass: 'p-2 border-top-0',
    centered: true
  }
}

LogistyConsts.install = function (Vue, options) {
  Vue.prototype.$getConst = (key) => {
    return LogistyConsts[key]
  }
}

export default LogistyConsts
